/* src/app/core/components/header/header.component.scss */
.toogle-menu {
  width: 32px;
  border-right: solid white 1px;
  margin-right: 0.625rem;
}
.toogle-menu button {
  border: none;
  background: transparent;
  color: white;
}
.toogle-menu button i {
  font-size: 1.5em;
}
.custom-navbar-brand::before {
  display: inline-block;
  width: 260px;
  height: 40px;
  margin-right: 0.5rem;
  content: " ";
  transform: translateY(0);
}
.brand-title {
  font-size: 2rem;
  margin-bottom: 0.15rem;
}
.custom-navbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.625rem;
}
.custom-navbar img {
  margin-left: -18px;
}
.fidal-link-bg {
  background-image: url(/assets/images/logoFidalEposte.png);
  background-repeat: no-repeat;
  margin-top: 0.625rem;
}
.logo-oxyane {
  width: 7rem;
}
.env-badge {
  position: fixed;
  top: 0;
  right: 0;
  font-weight: bold;
  text-transform: uppercase;
  color: #594a4a;
  border-bottom-left-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 9000;
  -webkit-user-select: none;
  user-select: none;
}
li.nav-item > button.nav-link > span {
  font-weight: bolder;
}
/*# sourceMappingURL=header.component.css.map */
